import React from "react";
import { getStatusStyle, formatDate } from "./constants";

const ContactNoteItem = ({ item }) => {
  const statusStyle = getStatusStyle(item.contact_result);

  return (
    <div className="contact-note-card">
      {/* Top Header: Result on Left, Status Badges on Right */}
      <div className="contact-note-header">
        <span className="contact-note-title">
          {item.contact_result || "-"}
        </span>
        <div className="contact-badge-group">
          {item.is_purchased && (
            <span className="purchase-badge">
              🛒 มีการซื้อ
            </span>
          )}
          {/* {item.contact_result && (
            <span
              className="contact-note-status-badge"
              style={{
                color: statusStyle.color,
                background: statusStyle.bg,
                borderColor: statusStyle.border,
              }}
            >
              {item.contact_result}
            </span>
          )} */}
        </div>
      </div>

      {/* Content Body */}
      <div className="contact-note-content-bubble">
        {item.description}
      </div>

      {item.contact_reason && item.contact_reason !== "-" && (
        <div style={{ fontSize: "11px", color: "#4b5563", marginTop: "6px", fontWeight: "500", wordBreak: "break-word", overflowWrap: "break-word" }}>
          สาเหตุ: <span style={{ color: "#1f2937", fontWeight: "600" }}>{item.contact_reason}</span>
        </div>
      )}

      {/* 2-Row Subtle Footer: ผู้บันทึก row 1 */}
      <div className="card-subtle-footer-stacked">
        <div className="d-flex justify-content-between align-items-center">
          <span>ผู้บันทึก: {item.create_by || "-"}</span>
          <span>สร้างเมื่อ: {formatDate(item.create_date)}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactNoteItem;
